import { AddOrUpdateInterestsAction } from '@modules/activate/components/AddOrUpdateInterestsAction/AddOrUpdateInterestsAction';
import { OracleSearchSuggestion } from '@modules/oracle/components/OracleSearchSuggestions/OracleSearchSuggestion';
import {
  useFetchWisdomSuggestions,
  usePostQuestion,
} from '@modules/oracle/hooks';
import { OracleSearchActionType } from '@modules/oracle/store/oracleActionType';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { trackWisdomEvents, updatePromptByID } from '@modules/oracle/utils';
import { Grid, Skeleton, Stack } from '@mui/material';
import { useState } from 'react';
import { useGetUser } from 'v2/core/services/user';
import './test.scss';

export function OracleSearchSuggestions() {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const dispatch = useOracleSearchStore(({ dispatch }) => dispatch);
  const promptByID = useOracleSearchStore(({ data }) => data.promptByID);
  const sessionID = useOracleSearchStore(({ data }) => data.sessionID);

  const [selectedSuggestion, setSelectedSuggestion] = useState('');

  const { suggestions, isLoading: areSuggestionsLoading } =
    useFetchWisdomSuggestions();

  const [postQuestion, { isLoading }] = usePostQuestion();

  const submitQuestion = async (question: string) => {
    setSelectedSuggestion(question);
    const resp = await postQuestion({
      question,
      shouldCreateChat: true,
    });

    const responseID = resp?.data?.getAssistantResponse?.responseID;

    if (!responseID) {
      return;
    }

    const updatedPromptByID = updatePromptByID({
      newPromptID: responseID,
      promptByID: promptByID ?? {},
      newPromptData: {
        question,
        userID,
        tenantID,
      },
    });

    dispatch({
      type: OracleSearchActionType.SET_DATA,
      payload: {
        promptByID: updatedPromptByID,
        currentPromptID: responseID,
      },
    });

    const suggestion = suggestions.find(
      (suggestion) => suggestion.question === question,
    );

    trackWisdomEvents({
      eventName: 'Wisdom - Preset Selected',
      responseID,
      searchText: question,
      sessionID,
      presetHeader: suggestion?.header,
      presetType: suggestion?.type,
    });
  };

  if (areSuggestionsLoading) {
    return (
      <Stack>
        <Grid container spacing={2} alignItems="stretch">
          {Array.from({ length: 4 }).map((_, index) => {
            return (
              <Grid item xs={6} key={index}>
                <Skeleton
                  variant="rectangular"
                  sx={{
                    borderRadius: 2.5,
                    minWidth: '140px',
                    minHeight: '120px',
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    );
  }

  return (
    <Stack spacing={2.5}>
      <Grid container spacing={2} alignItems="stretch">
        {suggestions.map((suggestion) => {
          return (
            <Grid item xs={6} key={suggestion.question}>
              <OracleSearchSuggestion
                suggestion={suggestion}
                onSelect={submitQuestion}
                isDisabled={isLoading}
                isLoading={
                  selectedSuggestion === suggestion.question ? isLoading : false
                }
              />
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <AddOrUpdateInterestsAction />
        </Grid>
      </Grid>
    </Stack>
  );
}
